import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";

const TurnOffBookingModal = ({ show, onHide, onConfirm, isLoading }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="turn-off-booking-modal-wrapper"
    >
      <Modal.Body className="pt-0 pb-2">
        <Modal.Header className="modal-title-with-border mb-0" closeButton>
          <Modal.Title>Turn Off Client Booking?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p className="mb-0">Are you sure?</p>
            <p className="mb-0">
              Your booking link will become inactive immediately. Clients will
              not be able to schedule new bookings.
            </p>
            <p className="mb-0">
              <strong>Note</strong>: Existing bookings are not affected.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="mt-0">
          <Button
            variant="outline-secondary"
            onClick={onHide}
            disabled={isLoading}
          >
            Keep On
          </Button>
          <Button variant="danger" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Turning Off...
              </>
            ) : (
              "Turn Off"
            )}
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default TurnOffBookingModal;
